export default __webpack_public_path__ + "static/peach-7b6c864f527a5cf467bdf1fb0350fe1a.svg";